import { Moment } from 'moment';
import { IClauseExtensionMySuffix } from 'src/app/shared/model//clause-extension-my-suffix.model';
import { IPolicyMySuffix } from 'src/app/shared/model/policy-my-suffix.model';

export const enum ActiveStatus {
    ACTIVE = 'ACTIVE',
    IN_ACTIVE = 'IN_ACTIVE'
}

export interface IScopeClauseSequenceInfo {
    id?: number;
    policyId?: number;
    scopeId?: number;
    clauseExtensionId?: number;
    clauseExtensionName?: string;
    sequence?: number;
}

export class ScopeClauseSequenceInfo implements IScopeClauseSequenceInfo {
    constructor(
        public id?: number,
        public policyId?: number,
        public scopeId?: number,
        public clauseExtensionId?: number,
        public clauseExtensionName?: string,
        public sequence?: number
    ) {}
}
